import MyAccountCancelModal from './MyAccountCancelModal'

export default MyAccountCancelModal
// eslint-disable-next-line import/export
export * from './MyAccountCancelModal'
